import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Calendar from '../../../../shared/components/Calendar';

const ProfileCalendar = () => (
  <Col md={12} lg={12} xl={12}>
    <Card>
      <CardBody className="profile__card--calendar">
        <Calendar small />
      </CardBody>
    </Card>
    <br />
  </Col>
);

export default ProfileCalendar;
